import { ClubSearchSelect } from '~/pages/club/components/club-search-select';
import { useUnsavedChangesGuard } from '~/hooks/useUnsavedChangesGuard';
import { schema, Schema } from './referee-license-form.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '~/components/Button/Button';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { useForm } from 'react-hook-form';

interface Props {
  onSubmit: (data: Schema) => void;
  mode: 'create' | 'edit';
  defaultValues?: Schema;
  isLoading: boolean;
}

export function RefereeLicenseForm({ defaultValues, mode, isLoading, onSubmit }: Props) {
  const { formState, register, handleSubmit, setValue, watch, trigger } = useForm({
    defaultValues: defaultValues ?? {},
    resolver: zodResolver(schema),
  });

  const { dialog } = useUnsavedChangesGuard(formState);

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <Grid>
        <Grid.Item cols={{ sm: 12, lg: 6 }}>
          <Input.Group formState={formState} htmlFor="club" label="Förening">
            <ClubSearchSelect
              placeholder="Sök på förening..."
              onChange={v => {
                setValue('club', v as [string, number], { shouldDirty: true });
                trigger('club');
              }}
              formState={formState}
              value={watch('club')}
            />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, lg: 6 }}>
          <Input.Group formState={formState} htmlFor="level" label="Nivå">
            <Input.Select
              {...register('level')}
              options={[
                ['Distriktsdomare', 'D'],
                ['Förbundsdomare', 'F'],
                ['Kat 1. Domare', 'K1'],
                ['Kat 2. Domare', 'K2'],
              ]}
              placeholder="Välj nivå"
              formState={formState}
              id="level"
              required
            />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, lg: 6 }}>
          <Input.Group formState={formState} htmlFor="start_date" label="Startdatum">
            <Input.Field type="date" {...register('start_date')} formState={formState} id="start_date" required />
          </Input.Group>
        </Grid.Item>

        <Grid.Item cols={{ sm: 12, lg: 6 }}>
          <Input.Group formState={formState} htmlFor="end_date" label="Slutdatum">
            <Input.Field type="date" {...register('end_date')} formState={formState} id="end_date" required />
          </Input.Group>
        </Grid.Item>
      </Grid>

      <Grid>
        <Grid.Item cols={{ sm: 12, lg: 6 }}>
          <Input.InlineGroup formState={formState} htmlFor="is_para" label="Paralicens?">
            <Input.Checkbox {...register('is_para')} formState={formState} />
          </Input.InlineGroup>
        </Grid.Item>
      </Grid>

      <Button.Group align="right">
        <Button type="submit" isLoading={isLoading}>
          {{ create: 'Skapa', edit: 'Spara' }[mode]}
        </Button>
      </Button.Group>

      {dialog}
    </form>
  );
}
